import { Component, Inject, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FlowControlService } from '../../../digitalvenue/services/flow-control.service';
import { APP_CONFIG } from "src/app/configuration/ticket-management-portal-configuration";
import { TicketManagementPortalConfiguration } from "src/app/configuration/ticket-management-portal-configuration.model";
import { ThemeSelectorService, UserService } from '../../../services';

@Component({
  selector: 'app-open-house-plan-modal',
  templateUrl: './open-house-plan-modal.component.html',
  styleUrls: ['./open-house-plan-modal.component.scss']
})
export class OpenHousePlanModalComponent implements OnInit {

  title: string;
  message: string;
  isDarkTheme: boolean;

  constructor(
              @Inject(APP_CONFIG) public app_config: TicketManagementPortalConfiguration,
              public bsModalRef: BsModalRef,
              public flowControl: FlowControlService,
              private userService: UserService,
              private themeSelector: ThemeSelectorService) {
  }

  ngOnInit() {
    this.title = "Upgrade your plan";
    this.message = "Please choose a new plan from the dropdown menu and choose your new seats.";
  }


  /**
   * Hides the modal
   */
  decline(): void {
    this.bsModalRef.hide();
  }

  getTheme() {
    return this.themeSelector.isDarkTheme;
  }

}